import { helper } from '@ember/component/helper';

import { toArray } from 'rise-ui/utils/array.js';
import regexEscape from 'rise-ui/utils/regex-escape.js';

const fields = [
  { key: 'title',         weight: 3 },
  { key: 'bodySummary',   weight: 2 },
  { key: 'bodyValue',     weight: 1 },
  { key: 'bodyProcessed', weight: 1 },
];

function helpPageRelevance(terms) {
  terms = terms.map(regexEscape).join('|');
  const matchTerms = new RegExp(`(^|[^a-z])(${terms})(?=[^a-z]|$)`, 'gi');
  return helpPage => fields.reduce((sum, field) => {
    const match = helpPage[field.key].match(matchTerms);
    return sum + (match ? match.length * field.weight : 0)
  }, 0);
}

export default helper(function helpPagesSortHelper([ helps, terms ]) {
  if (helps && terms && terms.length) {
    const getHelpPageRelevance = helpPageRelevance(terms);
    helps = toArray(helps, true)
      .sort((a, b) => getHelpPageRelevance(b) - getHelpPageRelevance(a));
  }
  return helps;
});
